import { EPaymentSummaryStatus } from 'features/PaymentsSummary/components/Status'
import { client } from 'gql/client'

export const updatePartnersPaymentSummaryStatus = (id: string, status: EPaymentSummaryStatus): void => {
  client.cache.modify({
    id: client.cache.identify({
      __typename: 'PartnersPaymentSummary',
      id: id
    }),
    fields: {
      status: (): string => status
    }
  })
}
